import { Price } from '@jouzen/ecom-components';
import type { RichTranslationValues } from 'next-intl';

import { useMembershipProduct } from '@/queries/Products';

export interface UseMembershipPricingProps {
  footnoteSymbol?: string;
}

const useMembershipPricing = ({
  footnoteSymbol,
}: UseMembershipPricingProps = {}): RichTranslationValues => {
  const { data: membershipData } = useMembershipProduct();

  const annualPrice = membershipData?.annual?.price?.amount;
  const monthlyPrice = membershipData?.monthly?.comparePrice?.amount;
  const hasAnnualPrice = typeof annualPrice === 'number';
  const hasMonthlyPrice = typeof monthlyPrice === 'number';

  // If either membership product wasn't returned in the query response, fallback to hardcoded USD values
  const useFallbackPricing = !hasAnnualPrice || !hasMonthlyPrice;
  const currencyCode = useFallbackPricing ? 'USD' : '';

  return {
    annualCost: () => (
      <Price
        currencyCode={currencyCode}
        price={useFallbackPricing ? 69.99 : annualPrice}
        showCurrency
      />
    ),
    footnoteLink: () => {
      return (
        <sup>
          <a href="#legal-footnotes">{footnoteSymbol}</a>
        </sup>
      );
    },
    monthlyCost: () => (
      <Price
        currencyCode={currencyCode}
        price={useFallbackPricing ? 5.99 : monthlyPrice}
        showCurrency
      />
    ),
  };
};

export default useMembershipPricing;
